enum SortOption {
  AcquisitionTime = 'AcquisitionTime',
  FreeShipping = 'FreeShipping',
  HighestPrice = 'HighestPrice',
  LowestMileage = 'LowestMileage',
  LowestPrice = 'LowestPrice',
  MostPopular = 'MostPopular',
  NewestInventory = 'NewestInventory',
  NewestYear = 'NewestYear'
}

export const SortOptionsWithLabels = [
  { label: 'Recommended', key: SortOption.MostPopular },
  { label: 'Lowest Shipping Cost', key: SortOption.FreeShipping },
  { label: 'Soonest Availability', key: SortOption.AcquisitionTime },
  { label: 'Newest Inventory', key: SortOption.NewestInventory },
  { label: 'Highest Price', key: SortOption.HighestPrice },
  { label: 'Lowest Price', key: SortOption.LowestPrice },
  { label: 'Newest Year', key: SortOption.NewestYear },
  { label: 'Lowest Mileage', key: SortOption.LowestMileage }
];

export default SortOption;
